<template>
  <div>
    <template v-for="(item, index) in options">
      <template v-if="values.includes(item.type)">
        <a-tag v-if="color"
               :color="getColor(index)"
               :index="index">
          {{ translate(item.name) }}
        </a-tag>
        <span :index="index" v-else>
          {{ translate(item.name) }}
        </span>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CustomDictTag',
  props: {
    options: {
      type: Array,
      default: null
    },
    value: {
      type: [Number, String, Boolean, Array],
      default: null
    },
    color: {
      type: [Boolean],
      default: false
    },
    colorArray: {
      type: Array,
      default: () =>{
        return ['green', 'blue', 'orange', 'purple', 'cyan', 'magenta', 'gold', 'lime', 'volcano'];
      }
    }
  },
  methods: {
    getColor(index) {
      //如果数组下标越界, 则返回green
      if (index > this.colorArray.length - 1) {
        return 'green'
      } else {
        return this.colorArray[index]
      }
    },
    // 将中文枚举名翻译为英文显示
    translate(name) {
      if (!name) return ''
      const map = {
        // LogisticsTypeEnum
        '快递': 'Express',
        '物流': 'Logistics',
        // FreightTypeEnum
        '按件数': 'By Quantity',
        '按重量': 'By Weight',
        // MerchantFreezeStatusEnum
        '待恢复': 'Pending Recovery',
        '已恢复': 'Recovered',
        '失效': 'Invalid'
      }
      const translated = this.$t(name)
      if (translated !== name) {
        return translated
      }
      return map[name] || name
    }
  },
  computed: {
    values () {
      if (this.value !== null && typeof this.value !== 'undefined') {
        return Array.isArray(this.value) ? this.value : [this.value]
      } else {
        return []
      }
    }
  }
}
</script>
